import { getInitData, getTestHeaders } from '../net/apiRequestHeaders';

/**
 * The game only runs inside Telegram (the backend authenticates by Telegram init
 * data). True for a production build opened in a plain browser; dev builds and
 * admin test sessions (test headers in localStorage) are let through.
 */
export function isOutsideTelegram(): boolean {
  if (!import.meta.env.PROD) return false;
  if (getInitData()) return false;
  return Object.keys(getTestHeaders()).length === 0;
}
